import { render, staticRenderFns } from "./ItemCategoryList.vue?vue&type=template&id=40a2db56&scoped=true&"
import script from "./ItemCategoryList.vue?vue&type=script&lang=js&"
export * from "./ItemCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./ItemCategoryList.vue?vue&type=style&index=0&id=40a2db56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a2db56",
  null
  
)

export default component.exports